import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { WHATSAPP_URL, trackWhatsAppConversion } from "../data/mediaAssets";

const Footer = () => {
    const { t } = useI18n();
    const nav = [
        { id: "home", label: t.nav.home },
        { id: "about", label: t.nav.about },
        { id: "tours", label: t.nav.tours },
        { id: "gallery", label: t.nav.gallery },
        { id: "contact", label: t.nav.contact },
    ];

    return (
        <footer
            data-testid="site-footer"
            className="bg-brand-navy-deep text-white pt-20 pb-8 relative overflow-hidden"
        >
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-gold to-transparent" />

            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-3 gap-14 mb-14">
                    <div>
                        <div className="flex items-baseline gap-2">
                            <span className="font-serif text-4xl md:text-5xl leading-none">CH</span>
                            <span className="font-sans text-xs uppercase tracking-[0.4em] text-brand-gold">
                                Tours
                            </span>
                        </div>
                        <p className="mt-6 font-sans text-white/70 text-sm max-w-xs leading-relaxed">
                            {t.footer.tagline}
                        </p>
                        <p className="mt-4 font-serif text-brand-gold italic text-lg leading-snug max-w-xs">
                            {t.footer.slogan}
                        </p>
                    </div>

                    <div>
                        <p className="font-sans text-[11px] uppercase tracking-[0.4em] text-brand-gold mb-6">
                            {t.footer.navigation}
                        </p>
                        <ul className="space-y-3">
                            {nav.map((item) => (
                                <li key={item.id}>
                                    <a
                                        href={`#${item.id}`}
                                        data-testid={`footer-nav-${item.id}`}
                                        className="font-sans text-sm text-white/80 hover:text-brand-gold transition-colors"
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <p className="font-sans text-[11px] uppercase tracking-[0.4em] text-brand-gold mb-6">
                            {t.footer.follow}
                        </p>
                        <div className="flex items-center gap-3">
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={trackWhatsAppConversion}
                                data-testid="footer-social-whatsapp"
                                aria-label="WhatsApp"
                                className="w-11 h-11 border border-white/25 hover:border-brand-gold hover:bg-brand-gold/10 flex items-center justify-center transition-all"
                            >
                                <MessageCircle className="w-5 h-5" />
                            </a>
                            <a
                                href="#"
                                data-testid="footer-social-instagram"
                                aria-label="Instagram"
                                className="w-11 h-11 border border-white/25 hover:border-brand-gold hover:bg-brand-gold/10 flex items-center justify-center transition-all"
                            >
                                <Instagram className="w-5 h-5" />
                            </a>
                            <a
                                href="#"
                                data-testid="footer-social-facebook"
                                aria-label="Facebook"
                                className="w-11 h-11 border border-white/25 hover:border-brand-gold hover:bg-brand-gold/10 flex items-center justify-center transition-all"
                            >
                                <Facebook className="w-5 h-5" />
                            </a>
                        </div>
                        <p className="mt-8 font-sans text-xs text-white/60">
                            christianjunio0611@icloud.com
                        </p>
                        <p className="mt-1 font-sans text-xs text-white/60">
                            +351 931 880 078
                        </p>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="font-sans text-xs text-white/50">
                        © {new Date().getFullYear()} CH TOURS. {t.footer.rights}
                    </p>
                    <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-white/40">
                        Sintra · Portugal
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
